export default __webpack_public_path__ + "static/media/Google Applied Digital Skill Write a business Plan.9da7c606.webp";